// Every paid method need to be at least 24 hours less
// than the fastest free method
export const DIFFERENCE_PAID_VS_FREE_SHIPPING = 24

// Minumim shipping time (magic value)
// By contract, the backend always returns shipping times >= this value
export const MIN_SHIPPING_TIME = 24

export const STEP_NAMES = {
  CATEGORY_SELECTION: 'categorySelection',
  DELIVERY_DEADLINE: 'deliveryDeadline',
  SUMMARY: 'summary',
}
